import { getDocs, collection } from "@firebase/firestore";
import { hideLoading, setItemCategoriesList, showLoading } from "./item-categories-list-slice";

export const getItemCategoriesService = async (dispatch, db, coll) => {
    dispatch(showLoading());
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemCategoriesList(data));
        });
    } catch(e) {
        console.error("ItemCategoriesList getItemCategoriesService error: ", e);
    }
    dispatch(hideLoading());
};